import '../styles/event.css';
import { choose } from '../utils/platform';
import NewEventModalDesktop from './NewEventModal.desktop';
import NewEventModalMobile from './NewEventModal.mobile';

// Platform chooser: the APK renders the mobile variant, any browser the desktop one.
export default choose(NewEventModalDesktop, NewEventModalMobile);
